export const checkPhone = (phone) => {
    const reg = /\d{11}/
    return reg.test(phone)
}

export const checkIdcardPattern = (code) => {
	const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
	return reg.test(code)
}


// 计算字符串在浏览器中的实际宽度
export const calcRealWidth = (text, fontStyle = '18px/1.6 "PingFang SC"') => {
	const canvas = document.createElement("canvas");
	const context = canvas.getContext("2d");
	context.font = fontStyle; // 设置字体样式，当然，也可以在这里给一个默认值
	const dimension = context.measureText(text);
	return dimension.width;
}

export const debounce = (fn, delay) => {
	let time = null;//time用来控制事件的触发
	return function () {
			if (time !== null) {
					clearTimeout(time);
			}
			time = setTimeout(() => {
					fn.call(this);
					//利用call(),让this的指针从指向window 转成指向input
			}, delay)
	}
}

// 获取文件名
export const getSuffix = (fileName) => {
	const name = fileName || ''
	let pos = name.lastIndexOf(".");
	let suffix = '';
	if (pos != -1) {
		suffix = name.substring(pos);
	}
	return suffix;
}

// 生成随机字符串
export const getRandomStr = (length) => {
	let str = ''
	for(let i = 0; i < length; i++) {
		str += getRandomKey()
	}
	return str
}

// 随机字符串
export const getRandomKey = () => {
	const base64Keys = [
		'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P',
		'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f',
		'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v',
		'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
	]
	return base64Keys[Math.floor(Math.random() * base64Keys.length)]
}